import React from 'react';
import { WorstOcrPage } from '../../services/analyticsService';

interface Props {
  pages: WorstOcrPage[];
}

export const WorstOcrTable: React.FC<Props> = ({ pages }) => {
  return (
    <div className="bg-white p-4 rounded-lg border">
      <h3 className="text-lg font-semibold mb-4">Top 10 pages OCR problematiques</h3>
      {pages.length === 0 ? (
        <p className="text-gray-500 text-center py-4">Aucune page problematique</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left">
              <th className="pb-2">Document</th>
              <th className="pb-2">Page</th>
              <th className="pb-2">OCR</th>
              <th className="pb-2">Erreurs</th>
            </tr>
          </thead>
          <tbody>
            {pages.map((page, idx) => (
              <tr key={idx} className="border-b last:border-0">
                <td className="py-2 font-mono text-xs truncate max-w-[150px]" title={page.filename}>
                  {page.filename}
                </td>
                <td className="py-2">p.{page.page}</td>
                <td className="py-2">
                  <span className={`font-medium ${
                    page.avg_ocr_confidence < 0.5 ? 'text-red-600' :
                    page.avg_ocr_confidence < 0.7 ? 'text-orange-600' : 'text-yellow-600'
                  }`}>
                    {(page.avg_ocr_confidence * 100).toFixed(0)}%
                  </span>
                </td>
                <td className="py-2">{page.error_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
